import { useTRPC } from "../../trpc";
import { useEffect } from "react";
import { Stack, Text, Title } from "@mantine/core";
import { useAllParams } from "../../hooks/router";
import { Link } from "../../components/Link";
import { FullPageLoader } from "../../components/FullPageLoader";
import { FormattedMessage } from "react-intl";
import { useSetUser } from "../../hooks/user";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigateUserAuth } from "./hooks/navigate";

export function ConfirmEmail() {
  const navigate = useNavigateUserAuth();
  const setUser = useSetUser();
  const trpc = useTRPC();

  const { token = "" } = useAllParams();

  const {
    data: isExpired,
    isFetching: isFetchingIfExpired,
  } = useQuery(trpc.checkIfExpired.queryOptions({ token }));

  const {
    mutateAsync: verifyEmail,
    isPending: isPendingVerification,
  } = useMutation(trpc.verifyEmail.mutationOptions());

  useEffect(() => {
    if (isExpired === false) {
      void verifyEmail({ token })
        .then((user) => {
          setUser(user);
          navigate(user);
        });
    }
  }, [token, isExpired, verifyEmail]);

  if (isFetchingIfExpired || isPendingVerification) {
    return (
      <FullPageLoader />
    );
  }

  return (
    <Stack>
      {isExpired && (
        <>
          <Title size="h3">
            <FormattedMessage id="title.linkExpired" defaultMessage="Link expired!" />
          </Title>
          <Text>
            <FormattedMessage
              id="text.expiredMessage"
              defaultMessage="Link expired, please sign in again to request a new one. If you do not get an email please check your spam folder."
            />
          </Text>
          <Link underline="always" href="../sign-in">
            <FormattedMessage id="link.returnToSignIn" defaultMessage="Return to sign in" />
          </Link>
        </>
      )}
    </Stack>
  );
}
